export const getPath = (activeLink: string): string => {
    const p = activeLink.split('/')
    return `/${p[1]}`
}
